export enum FeatureToggle {
    STOCKOUTS = "Stockout",
}

export const IsFeatureToggleEnabled = (featureName: string): boolean => {
    return window.__CONFIG__.FeatureFlags[featureName];
};
